import { useCallback, useEffect, useState } from "react";
import { countryData1 } from "../shared/data";
import { geoItem } from "../components/CountryCode/types";

export const useCountryCode = () => {
    console.log('Количество ГЕО - ', countryData1.length)
    const [value, setValue] = useState<geoItem>(countryData1[0]);
    const [search, setSearch] = useState<string>('');
    const [filterCountryData, setFilterCountryData] = useState<geoItem[] | null>(null);
    const [aftereffect, setAftereffect] = useState<boolean>(false);
    const arabCountry = ['MA', 'SA', 'LB', 'LY', 'AE', 'DZ'];

    const setTemporarilyAftereffect = () => {
        setAftereffect(true)
        setTimeout(() => {
            setAftereffect(false)
        }, 4000)
    }

    const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setValue(countryData1.filter((geo: geoItem) => geo.name === e.target.value)[0]);
        setTemporarilyAftereffect()
    };

    const handleChangeSelectBeforeSearch = (target: string) => {
        setValue(countryData1.filter((geo: geoItem) => geo.name === target)[0]);
        setTemporarilyAftereffect()
    };

    const sortCountryDataArray = (x: geoItem, y: geoItem) => {
        if (x.name < y.name) { return -1; }
        if (x.name > y.name) { return 1; }
        return 0;
    }

    const searchFilterCountryData = useCallback(() => {
        if (search !== '') {
            setFilterCountryData(countryData1.filter((geo: geoItem) => geo.name.toLowerCase().includes(search.toLowerCase())))
        }
    }, [search])

    useEffect(() => {
        searchFilterCountryData()
    }, [searchFilterCountryData])


    return {
        aftereffect,
        countryData: countryData1,
        value,
        handleChangeSelect,
        sortCountryDataArray,
        search,
        setSearch,
        filterCountryData,
        handleChangeSelectBeforeSearch,
        arabCountry,
    }
}